module.exports = __webpack_public_path__ + "static/img/2_4_2.3b4213dc.jpg";